import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-cream relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-light/30 via-cream to-cream pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-forest" data-id="element-95">
            El próximo lunes puedes seguir improvisando...
            <br data-id="element-96" />
            <span className="text-terracotta" data-id="element-97">
              O puedes entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-beige shadow-sm" data-id="element-98">
            {['Sin más noches buscando cómo hacer que 40,000 años de historia quepan en una clase de 50 minutos', 'Sin más clases armadas de apuro con material que no conecta con tus alumnos', 'Sin más alumnos que preguntan para qué sirve estudiar historia y no tienes una respuesta que los enganche', 'Sin más silencios incómodos cuando un alumno pregunta la diferencia real entre el Clásico y el Posclásico', 'Sin más fines de semana perdidos construyendo actividades y evaluaciones desde cero', 'Sin más culpa de sentir que tus alumnos merecen más de lo que el tiempo te permite darles'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-terracotta mt-1" data-id="element-100">▸</span>
                <span className="text-ink font-medium" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-ink mb-2 font-medium" data-id="element-102">
            El Mega Pack Historia México 360 no te convierte en mejor docente.
          </p>
          <p className="text-2xl font-bold text-forest mb-6" data-id="element-103">
            Vos ya eres un buen docente.
          </p>
          <p className="text-xl text-warmgray mb-16 font-medium" data-id="element-104">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase.
          </p>
        </div>

        <div className="bg-white border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(201,162,75,0.15)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-forest mb-6 text-center border-b border-beige pb-6" data-id="element-106">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Tomo 1 — Prehistoria y Culturas Madre de Mesoamérica', 'Tomo 2 — El Período Clásico, Teotihuacán y los Mayas', 'Tomo 3 — El Posclásico, los Mexicas y la Conquista', 'Tomo 4 — El Virreinato de la Nueva España', 'Tomo 5 — La Independencia y el Siglo XIX', 'Tomo 6 — El Porfiriato y la Revolución Mexicana', 'Tomo 7 — El México Moderno y Contemporáneo hasta 2024', 'Bono 1 — Banco de Actividades Didácticas', 'Bono 2 — Banco de Evaluaciones y Rúbricas', 'Bono 3 — Proyectos Integradores Anuales', 'Bono 4 — Glosario Técnico de Historia de México', 'Bono 5 — Recursos de Pensamiento Histórico', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-olive shrink-0" data-id="element-109" />
                <span className="text-sm text-ink font-medium" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-ivory rounded-xl border border-beige italic text-ink text-lg font-medium" data-id="element-112">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" />
              <span className="text-terracotta font-bold not-italic" data-id="element-114">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-forest mb-2" data-id="element-115">
              📚 Mega Pack Historia México 360
            </p>
            <p className="text-sm text-warmgray mb-8 font-medium" data-id="element-116">
              Hecho por especialistas, para docentes de México y de todo el
              mundo hispanohablante.
            </p>

            <Button href="#pricing" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-warmgray font-medium" data-id="element-118">
              <span data-id="element-119">✅ Garantía de 7 días</span>
              <span data-id="element-120">✅ Pago seguro</span>
              <span data-id="element-121">✅ Acceso inmediato</span>
              <span data-id="element-122">✅ Pagas en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}